export function formatCountdown(seconds) {
  if (seconds === null) return '';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function getServicePrice(service) {
  if (!service) return 0;
  return service.price_info?.sale_price || service.price_info?.final_price || service.price || 0;
}

export function getTherapistPrice(service, therapist) {
  if (!service || !therapist || therapist.Id === 'any' || therapist.id === 'any') {
    return getServicePrice(service);
  }
  // Therapist has a custom price field from the sync cache
  const customPrice = therapist.Price !== null ? therapist.Price : null;
  return customPrice !== null ? customPrice : getServicePrice(service);
}

export function stripHtml(html) {
  return (html || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function truncateText(text, maxLen = 200) {
  if (!text || text.length <= maxLen) return text;
  return text.substring(0, maxLen).replace(/\s+\S*$/, '') + '...';
}

export function getTherapistName(t) {
  if (!t) return 'Unknown';
  return t.DisplayName || t.Name || t.name || 'Unknown';
}

export function formatPhoneInput(value) {
  const digits = value.replace(/\D/g, '');
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function formatDayName(date) {
  return date.toLocaleDateString('en-US', { weekday: 'short' }).toUpperCase();
}

export function formatMonthYear(date) {
  return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' }).toUpperCase();
}

export function formatTime(timeStr) {
  const d = new Date(timeStr);
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
}

export function isSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}

export function isToday(date) {
  return isSameDay(date, new Date());
}

export function isPast(date) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d < today;
}

export function groupSlotsByPeriod(slots) {
  const morning = [], afternoon = [], evening = [];
  slots.filter(s => s.Available).forEach(slot => {
    const hour = new Date(slot.Time).getHours();
    if (hour < 12) morning.push(slot);
    else if (hour < 17) afternoon.push(slot);
    else evening.push(slot);
  });
  return { morning, afternoon, evening };
}

export function getRecommendedTimes(slots) {
  const { morning, afternoon, evening } = groupSlotsByPeriod(slots);
  const recommended = [];
  if (morning.length > 0) recommended.push(morning[0]);
  if (afternoon.length > 0) recommended.push(afternoon[0]);
  if (evening.length > 0) recommended.push(evening[0]);
  return recommended;
}

export function getWeekDays(start) {
  const days = [];
  const d = new Date(start);
  for (let i = 0; i < 7; i++) {
    days.push(new Date(d));
    d.setDate(d.getDate() + 1);
  }
  return days;
}
